export default __webpack_public_path__ + "images/OG.6c4c27d.png";